import { createSelector } from 'reselect'
import { IModal, Modals } from '../types/modal'
import { AppStateType } from '../reducers'

export const selectActiveModal = createSelector(
  [(state: AppStateType) => state.modal],
  (modal: IModal): Modals | undefined => modal.id
)

export const selectModal = createSelector(
  [(state: AppStateType) => state.modal],
  (modal: IModal) => modal
)
